export const categories1 = [
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "333.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "123.246",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "99.675",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
  {
    title: "City house",
    content: "Small description",
    counter: "256.356",
    icon: "building",
    url: "/stays-category",
  },
];

export const categories2 = [
  {
    title: "South Virgilland",
    content: "From Rs. 1,461 per day",
    counter: "128",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "Purdyhaven",
    content: "From Rs. 1,461 per day",
    counter: "245",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "Port Jarrett",
    content: "From Rs. 1,461 per day",
    counter: "95",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "New Kristian",
    content: "From Rs. 1,461 per day",
    counter: "222",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "Demetrisfort",
    content: "From Rs. 1,461 per day",
    counter: "544",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "South Virgilland",
    content: "From Rs. 1,461 per day",
    counter: "128",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "Purdyhaven",
    content: "From Rs. 1,461 per day",
    counter: "245",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "Port Jarrett",
    content: "From Rs. 1,461 per day",
    counter: "95",
    icon: "car",
    url: "/cars-category-2",
  },
  {
    title: "New Kristian",
    content: "From Rs. 1,461 per day",
    counter: "222",
    icon: "car",
    url: "/cars-category-2",
  },
];
